// extracted by mini-css-extract-plugin
module.exports = {"header":"channels-header__3lw8b","title":"channels-title__3MgXp","buttons":"channels-buttons__Jdh1G"};